export enum SegmentStatus {
    MatchingStarted,
    IdentifiersFileCreated,
    CalculatingLookAlikePercentages,
    CalculatingSegmentInsights,
    Success,
    Error
}